module.exports = __webpack_public_path__ + "img/qr_icon.d0ec2cf3.svg";